import { Component, Input, ViewChild } from '@angular/core';
import moment from 'moment';
import { LocationsProvider } from '../../providers/locations/locations';
import { ReserveProvider } from '../../providers/reserve/reserve';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoReserveRoomCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reserve-room-card',
  templateUrl: 'co-reserve-room-card.html',
  inputs: ['roomDetails', 'currentDay', 'location', 'clientKeyword', 'timezoneOffset', 'locationIndex', 'roomIndex', 'cardStyle', 'allReservations', 'isCostEnabled', 'roomIdAddedToCart']
})
export class CoReserveRoomCardComponent {
  @Input('roomDetails') roomDetails;
  @Input('currentDay') currentDay;
  @Input('location') location;
  @Input('clientKeyword') clientKeyword;
  @Input('timezoneOffset') timezoneOffset;
  @Input('locationIndex') locationIndex; //for determining which location is closed
  @Input('roomIndex') roomIndex; //for determining which room no longer has any available time
  @Input('cardStyle') cardStyle; //for determining which card style should be shown
  @Input ('allReservations') allReservations;
  @Input ('isCostEnabled') isCostEnabled;
  @Input('roomIdAddedToCart') roomIdAddedToCart;
  @Input('roomTitleFontSize') roomTitleFontSize;
  @ViewChild('eventCardContainer') eventCardContainer;
  weekHours: any;
  todayHours: { start: string, end: string } = { start: '', end: '' };
  pageHours: { start: string, middle: string, end: string } = { start: '', middle: '', end: '' };
  pageTimeline: any = [{}];
  firstSelected: any;
  secondSelected: any;
  timelineStepIntervalSetting: number = 96;
  timelineScrollBar: number = 0;
  currentDayReservations: any;
  branchClosedToday: boolean = false;
  isTimelineLoaded: boolean = false;
  timelineBoxInterval: number = 15;
  widthOfTimelineBox: number;
  locationTitle: any;
  unAvailable: boolean;
  timelineArrayForFilterCheck: Array<string>;

  constructor(public locationsProvider: LocationsProvider, public reserveProvider: ReserveProvider, public client: ClientDetailsProvider, private state: AppState) {
  }

  ngOnInit() {
    this.initializeCard(this.currentDay, this.allReservations);
  }

  initializeCard(currentDay, reservations) {
    this.currentDayReservations = [];
    this.roomDetails.events = [];
    reservations.forEach(reservation => {
      if (reservation.roomId === this.roomDetails.id) {
        this.currentDayReservations.push(reservation);
        this.roomDetails.events.push(reservation);
      } else if (this.roomDetails.parents && this.roomDetails.parents.indexOf(reservation.roomId.toString())!== -1){
        this.roomDetails.events.push(reservation);
      } else if (this.roomDetails.children && this.roomDetails.children.indexOf(reservation.roomId.toString()) !== -1) {
        this.roomDetails.events.push(reservation);
      }
    });
    this.currentDay = currentDay;
    this.getLocationHours(this.location, this.currentDay);
  }

  buildArray() {

    if(moment(this.currentDay).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
      //this will make sure that the time is correct
      this.currentDay = moment();
    }

    this.branchClosedToday = false;
    this.unAvailable = true;
    let locationTime: { start: any, end: any } = { start: '', end: '' }
    let startTime = [this.todayHours.start.split(':')[0], this.todayHours.start.split(':')[1].split(' ')[0]];
    let endTime = [this.todayHours.end.split(':')[0], this.todayHours.end.split(':')[1].split(' ')[0]];
    locationTime.start = moment(this.currentDay).hour(Number(startTime[0])).minute(Number(startTime[1])).startOf('minute');
    locationTime.start.subtract(this.roomDetails.dayStartBuffer, 'minutes');
    locationTime.end = moment(this.currentDay).hour(Number(endTime[0])).minute(Number(endTime[1])).startOf('minute');
    locationTime.end.subtract(this.roomDetails.dayEndBuffer, 'minutes');

    this.pageHours.start = locationTime.start;
    this.pageHours.end = locationTime.end;
    this.pageHours.middle = moment(locationTime.start).add(moment(locationTime.end).diff(locationTime.start, 'minutes') / 2, 'minutes').toString();

    let outputArray = [];
    let currentTimeOfDay = moment(this.currentDay).startOf('hour').hour(locationTime.start.hour()).minute(locationTime.start.minute());

    let widthMultiplier = 0; //add 1 for each itteration
    let lastBlockType;
    let typeToPush;

    let isBranchClosed = (locationTime.start).isSame(locationTime.end);

    let roomHours = this.roomDetails.roomHours[moment(this.currentDay).day()];
    let roomTime: { start: any, end: any } = { start: '', end: '' }

    let isRoomClosed = null;

    if(roomHours) {
      let roomStartTime = [roomHours.start.split(':')[0], roomHours.start.split(':')[1].split(' ')[0]];
      let roomEndTime = [roomHours.end.split(':')[0], roomHours.end.split(':')[1].split(' ')[0]];

      roomTime.start = moment(this.currentDay).hour(Number(roomStartTime[0])).minute(Number(roomStartTime[1])).startOf('minute');
      roomTime.start.subtract(this.roomDetails.dayStartBuffer, 'minutes');

      roomTime.end = moment(this.currentDay).hour(Number(roomEndTime[0])).minute(Number(roomEndTime[1])).startOf('minute');
      roomTime.end.subtract(this.roomDetails.dayEndBuffer, 'minutes');

      isRoomClosed = moment(roomHours.start).isSame(moment(roomHours.end));
    }

    if(isBranchClosed || !isRoomClosed) {
      this.pageHours.start = roomTime.start;
      this.pageHours.end = roomTime.end;
      this.pageHours.middle = moment(roomTime.start).add(moment(roomTime.end).diff(roomTime.start, 'minutes') / 2, 'minutes').toString();
    }

    let segments;
    try {
        segments = new Array(Math.ceil((moment(this.pageHours.end).diff(this.pageHours.start, 'minutes')) / this.timelineBoxInterval));
    } catch (ex) {
      // console.log(this.location);
      segments = [];
      this.branchClosedToday = true;
    }

    if(null != isRoomClosed && !isRoomClosed) {
      this.unAvailable = false;
      currentTimeOfDay = moment(this.currentDay).startOf('hour').hour(roomTime.start.hour()).minute(roomTime.start.minute());
    }

    if (isBranchClosed && isRoomClosed) {
      if (this.cardStyle === "standard") {
        // this.parentRoomCardContainer.setAttribute('style', 'display: none;');
        // this.locationTitle.setAttribute('style', 'display: none;');
      }
      this.branchClosedToday = true;
    } else {
      if (this.cardStyle === "standard") {
        // this.parentRoomCardContainer.setAttribute('style', 'display: block;');
      } else if (this.cardStyle === "tablet") {
        // this.parentRoomCardContainer.setAttribute('style', 'display: inline-block;');
      }
      // this.locationTitle.setAttribute('style', 'display: block;');
      for (let i = 0; i <= segments.length; i++) {
        let push = false;

        if (currentTimeOfDay.isBefore(roomTime.start)
            || currentTimeOfDay.isSameOrAfter(roomTime.end)
            || moment(currentTimeOfDay).isSameOrBefore(moment().startOf('minute'))
        ) {
          if (lastBlockType === true) {
            push = true;
            typeToPush = true;
          }
          lastBlockType = false;
          // outputArray.push(false);
        } else {
          // if reservations exist
          if (this.currentDayReservations.length > 0) {
            let alreadyChecked = false;
            this.currentDayReservations.forEach(reservation => {
              if ((currentTimeOfDay.isBetween(moment(reservation.startTime).startOf('minute'),
                    moment(reservation.endTime).endOf('minute'))
                  )
                  || currentTimeOfDay.isSame(moment(reservation.startTime).startOf('minute'))
              ) {
                if (!alreadyChecked) {
                  alreadyChecked = true;
                  if (lastBlockType === true) {
                    push = true;
                    typeToPush = true;
                  }
                  lastBlockType = false;
                }
              }
            });
            if (!alreadyChecked) {
              alreadyChecked = true;
              this.unAvailable = false;
              if (lastBlockType === false) {
                push = true;
                typeToPush = false;
              }
              lastBlockType = true;
            }
          //if no reservations
          } else {
            this.unAvailable = false;
            if (lastBlockType === false) {
              push = true;
              typeToPush = false;
            }
            lastBlockType = true;
          }
        };
        // i===segments.length - 1 to remove possiblity of pushing the wrong boolean for the last block
        if (push || i === segments.length || i === segments.length - 1) {
          push = false;
          if (typeToPush === undefined) {
            typeToPush = lastBlockType;
          }
          if (widthMultiplier === 0) {
            widthMultiplier = 1;
          }

          //added if below because the last block of some reservations would return false if they're preceeded by an event even though the event ends 15 minutes before the end of the day
          if (i === segments.length) {
            this.currentDayReservations.forEach(reservation => {
              if (currentTimeOfDay.isBetween(moment(reservation.startTime).startOf('minute'),
                    moment(reservation.endTime).endOf('minute'))
                  || currentTimeOfDay.isSame( moment(reservation.startTime).startOf('minute'))
              ) {
                typeToPush = false;
              } else {
                typeToPush = true;
              }
            });
          }

          let widthPercent = (100 / segments.length) * widthMultiplier;
          let block: any = { bookable: typeToPush, widthPercent: widthPercent };
          typeToPush = undefined;
          widthMultiplier = 0;
          outputArray.push(block);
        }
        widthMultiplier++;
        currentTimeOfDay = currentTimeOfDay.add(this.timelineBoxInterval, 'minutes');
      };
    }

    this.pageTimeline = outputArray;
    this.widthOfTimelineBox = 100 / this.pageTimeline.length;
    this.isTimelineLoaded = true;
  };

  returnTimelineArrayForFilter() {
    return this.timelineArrayForFilterCheck;
  }

  getLocationHours(location, day) {
    this.branchClosedToday = false;
    let todayNumber = moment(day).day();
    this.todayHours.start = location.locationHours[todayNumber].start;
    this.todayHours.end = location.locationHours[todayNumber].end;
    if (this.cardStyle === "standard") {
      this.buildArray();
    }
    else if (this.cardStyle === "tablet") {

    }
  };

  roomMaxCapacity() {
    return Math.max(this.roomDetails.capacityChairs, this.roomDetails.capacityStanding, this.roomDetails.capacityTables);
  };

  checkAvailability(currentRoom, i) {
    //the time selected
    let currentTime = moment(this.currentDay);
    //Ensure that the time component of the moment is correct if the currentTime is for today
    if(moment(currentTime).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
      currentTime = moment();
    }
    let hourSet = this.getHours(currentRoom);

    if(this.isClosedForDay(hourSet, currentTime.day())) {
      return false;
    }

    const [ start, end ] = this.getOpenAndCloseHours(hourSet, currentTime.day());

    if (moment(currentTime).startOf('day').isAfter(moment().startOf('day'))) {
      return true;
    }
    let locationOpen = start.startOf('minute').subtract(this.roomDetails.dayStartBuffer, 'minutes');
    let locationClose = end.startOf('minute').subtract(this.roomDetails.dayEndBuffer, 'minutes');

    if (currentTime.isBefore(locationOpen)) {
      return false;
    }

    if (currentTime.isAfter(locationClose)) {
      return false;
    }

    let lastBookingTime = moment(locationClose).subtract(this.roomDetails.segmentSizeInMinutes + this.roomDetails.setupTime + this.roomDetails.breakdownTime, 'minutes');
    if (currentTime.isSameOrAfter(lastBookingTime)) {
      return false;
    }

    if (currentRoom.events.length === 0) {
      return true;
    }

    let available: boolean = true;
    // if (this.roomEvents.length == this.allRooms.length) {
    if (currentRoom.events.length > 0) {
      currentRoom.events.forEach(event => {
        if (currentTime.isBetween(moment(event.startTime).subtract((currentRoom.segmentSizeInMinutes * currentRoom.segmentsPerBlock) + 1,'minute'), moment(event.endTime)) && available) {
          available = false;
        }
      });
    }
    else {
      available = true;
    }
    // }
    return available;
  }

  getNextReservation(room, i) {
    let currentTime = moment(this.currentDay);
    if (moment(currentTime).startOf('day').isAfter(moment().startOf('day'))) {
      currentTime.startOf('day');
    }

    let openingHours = this.location.locationHours;
    //replace openingHours with roomHours if present.
    if(room.roomHours[moment(this.currentDay).day()]) {
      openingHours = room.roomHours;
    }

    let end = [
      openingHours[moment(this.currentDay).day()].end.split(':')[0],
      openingHours[moment(this.currentDay).day()].end.split(':')[1].split(' ')[0]
    ];

    if (!room.events) {
      return moment(this.currentDay).hour(end[0]).minute(end[1]).subtract(this.roomDetails.dayEndBuffer, 'minutes').format("YYYY-MM-DD HH:mm:ss");
    }

    // if (this.roomEvents.length == this.allRooms.length) {
      if (room.events.length > 0) {

        let availableTime, alreadyChecked;
        alreadyChecked = false;

        room.events.forEach(event => {
          if (currentTime.isBefore(moment(event.startTime)) && !alreadyChecked) { //if is before event
            alreadyChecked = true;
            // console.log(event);
            availableTime = moment(event.startTime);
          }
        });

      if (alreadyChecked) {
        if (availableTime.seconds() === 59) {
          availableTime.add(1, 'minute').startOf('minute');
        }
        // console.log(availableTime);
        return availableTime.format("YYYY-MM-DD HH:mm:ss");
      }

      return moment(this.currentDay).hour(end[0]).minute(end[1]).subtract(this.roomDetails.dayEndBuffer, 'minutes').format("YYYY-MM-DD HH:mm:ss");
    }
    // }
    else {
      return moment(this.currentDay).hour(end[0]).minute(end[1]).subtract(this.roomDetails.dayEndBuffer, 'minutes').format("YYYY-MM-DD HH:mm:ss");
    }
  }

  getHours(room) {
    let hourSet = this.location.locationHours;
    if(room.roomHours) {
      hourSet = room.roomHours;
    }
    return hourSet;
  }

  fullyBooked(room, i) {

    let currentTime = moment(this.currentDay);
    let hourSet = this.getHours(room);

    if(this.isClosedForDay(hourSet, currentTime.day())) {
      return true;
    }

    const [ start, end ] = this.getOpenAndCloseHours(hourSet, currentTime.day());

    let locationClose = end.startOf('minute').format("YYYY-MM-DD HH:mm:ss");
    let available = false;

    // if (this.roomEvents.length == this.allRooms.length) {
    if (!room.events) {
      return false;
    }

    if (room.events.length > 0) {
      room.events.forEach(event => {
        if (moment(event.endTime).isSameOrAfter(locationClose) && currentTime.isBetween(moment(event.startTime).subtract(1,'minute'), moment(event.endTime))) {
          available = true;
        }
      });
    }
    // }

    return available;
  }

  isClosedForDay(hourSet, day) {
    let openingHours = hourSet[day];
    return ('0:00' == openingHours.start && '0:00' == openingHours.end);
  }

  getOpenAndCloseHours(hourSet, day) {
    let openingHours = hourSet[day];
    let start = moment(openingHours.start, "H:mm").isoWeekday(openingHours.day);
    let end = moment(openingHours.end, "H:mm").isoWeekday(openingHours.day);

    return [ start, end ];
  }

  getNextFree(room, i) {
    if(moment(this.currentDay).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
      //this will make sure that the time is correct
      this.currentDay = moment();
    }
    let currentTime = moment(this.currentDay);
    let hourSet = this.getHours(room);
    const [ start, end ] = this.getOpenAndCloseHours(hourSet, currentTime.day());
    let tomorrowDay = moment(currentTime).add(1, 'day');
    const [ startTomorrow ] = this.getOpenAndCloseHours(hourSet, tomorrowDay.day());

    let available: any = moment(start).subtract(this.roomDetails.dayStartBuffer, 'minutes').format("YYYY-MM-DD HH:mm:ss");
    let openingTime = moment(start).subtract(this.roomDetails.dayStartBuffer, 'minutes');
    let closingTime = moment(end).subtract(this.roomDetails.dayEndBuffer, 'minutes');

    let openingTimeTomorrow = startTomorrow.subtract(this.roomDetails.dayStartBuffer, 'minutes');

    if (currentTime.isBefore(openingTime)) {
      return openingTime.format("YYYY-MM-DD HH:mm:ss");
    } else if (currentTime.isAfter(closingTime)) {
      return openingTimeTomorrow.format("YYYY-MM-DD HH:mm:ss");
    }
    // if (!room.events) {
    //   return available;
    // }

    // if (this.roomEvents.length == this.allRooms.length) {
    if (room.events.length > 0) {
      room.events.forEach(event => {
        if (currentTime.isBetween(moment(event.startTime).subtract((room.segmentSizeInMinutes * room.segmentsPerBlock) + 1, 'minute'), moment(event.endTime)) || moment(available).isBetween(moment(event.startTime).subtract((room.segmentSizeInMinutes * room.segmentsPerBlock) - 1), moment(event.endTime))) {
          available = moment(event.endTime);
        }
      });
    }
    // }
    // If next available time is at or after closing time, return tomorrow's opening time
    if (moment(available).isSameOrAfter(closingTime)) {
      return openingTimeTomorrow.format("YYYY-MM-DD HH:mm:ss");
    }
    return available;
  }

}



// WEBPACK FOOTER //
// ./src/components/co-reserve-room-card/co-reserve-room-card.ts